// extensions/CustomTableHeader.ts
import TableHeader from '@tiptap/extension-table-header';

export const CustomTableHeader = TableHeader.extend({
  content: 'block+',

  addAttributes() {
    return {
      ...this.parent?.(),
      role: {
        default: null,
        parseHTML: el => el.getAttribute('data-role'),
        renderHTML: a => (a.role ? { 'data-role': a.role } : {}),
      },
      hidden: {
        default: false,
        parseHTML: el => el.getAttribute('data-hidden') === 'true',
        renderHTML: attrs =>
          attrs.hidden ? { 'data-hidden': 'true', style: 'display:none;' } : {},
      },
    };
  },
});
